import Cookies from 'js-cookie'
import v4 from 'uuid/v4'

import { debug, enableDebug, subscribe } from './utilities'

export function preEasysize () {
  let params = {
    'product': {},
    'products': [],
    'shop': {},
    'device': {},
    'button': {},
    'features': {},
    'easysize': {},
    'calculated_size': {},
    'elements': {},
    'experiment': {}
  }

  window.EasySizeParametersDebug = params
  window.EasySizeDebugEnable = enableDebug

  // EasySize data
  params.easysize.api_url = Cookies.get('apiURL') ? Cookies.get('apiURL') : 'https://api.easysize.me/v1/'
  params.easysize.widget_url = Cookies.get('popupURL') ? Cookies.get('popupURL') : 'https://popup.easysize.me/'
  params.easysize.qa_widget_url = Cookies.get('qa_widget_url') ? Cookies.get('qa_widget_url') : 'https://feedback.easysize.me/qa/'
  params.easysize.tracking_url = Cookies.get('es_tracking_url') ? Cookies.get('es_tracking_url') : 'https://tracking.easysize.me/'
  // params.easysize.api_url = "https://testing.easysize.me/v1/";
  // params.easysize.widget_url = "http://127.0.0.1:3000/";
  params.easysize.user_id = -1
  params.easysize.user_type = 'n'
  params.easysize.calculated_size_proven_by = 100
  params.easysize.tracking_started = false

  params.easysize.external = {
    'cookies': Cookies,
    'v4': v4
  }

  let tracking
  params.easysize.uuid = window.easysize_tracking_id || v4()
  params.easysize.session_id = Cookies.get('_shopify_s')
  params.easysize.pageview_id = params.easysize.uuid

  /* eslint-disable camelcase */
  let easysize_user_id_received = false
  let easysize_product_validated = false
  let recognize_user_loaded = false

  System.import('./tracking').then(module => {
    tracking = module.tracking(params)
  })

  subscribe('easysize_user_id_received', () => {
    debug('[EasySize debug]: easysize_user_id_received: ', params.easysize.user_id)
    recognizeUserType(true, null)

    if (params.easysize.user_id == -1) { // eslint-disable-line
      /* If easysize user id was not defined, save it */
      params.easysize.user_id = params.easysize.uuid
      System.import('./easysize-user').then(module => {
        module.saveEasySizeUserId(params)
      })
      document.body.classList.add('easysize_new_user_infotip')
    }
  })

  System.import('./easysize-user').then(module => {
    module.getEasySizeUserId(params)
  })

  subscribe('easysize_product_validated', (args) => {
    debug('[EasySize debug]: easysize_product_validated')
    recognizeUserType(null, true)
  })

  subscribe('easysize_user_type_identified', (user_type) => {
    debug('[EasySize debug]: easysize_user_type_identified: ', user_type)
    tracking.init(params)
  })

  subscribe('easysize_tracking_initiated', () => {
    System.import('./features').then(module => {
      module.enableEasySizeFeatures(params)
    })
  })

  function recognizeUserType (local_easysize_product_validated, local_easysize_user_id_received) {
    if (local_easysize_product_validated) { easysize_product_validated = true }
    if (local_easysize_user_id_received) { easysize_user_id_received = true }

    if (easysize_product_validated && easysize_user_id_received && !recognize_user_loaded) {
      recognize_user_loaded = true
      System.import('./easysize-user').then(module => {
        module.recognizeUserType(params)
      })
    }
  }

  return params
  /* eslint-enable camelcase */
}



// WEBPACK FOOTER //
// ./src/js/components/easysize-pre-start.js